import { useCallback, useEffect, useState } from "react";
import { api, errDetail, fmtDate } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Radio, RefreshCw } from "lucide-react";

const STATUS = { ack: ["bg-green-100 text-green-700", "bestätigt"], sent: ["bg-blue-100 text-blue-700", "gesendet"], error: ["bg-red-100 text-red-700", "Fehler"] };

export default function ErpMonitor() {
  const [msgs, setMsgs] = useState([]);
  const [dls, setDls] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    api.get("/srm/erp/messages").then((r) => setMsgs(r.data || [])).catch((e) => toast.error(errDetail(e)));
    api.get("/srm/erp/dead-letters").then((r) => setDls(r.data || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const retry = async (dl) => { setBusy(true); try { await api.post(`/srm/erp/dead-letters/${dl.id}/retry`); toast.success("Erneut gesendet"); load(); } catch (e) { toast.error(errDetail(e)); } finally { setBusy(false); } };
  return (
    <div className="p-6 max-w-[1300px] mx-auto" data-testid="erp-monitor-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-11 w-11 rounded-xl bg-[#1B2A4A] flex items-center justify-center"><Radio className="h-5 w-5 text-[#F5A623]" /></div>
        <div><h1 className="text-2xl font-bold text-[#1B2A4A]">ERP-Nachrichten-Monitor</h1><p className="text-sm text-gray-500">Ausgehende Belege (PO/GR/Rechnung) · Dead-Letter mit Wiederholung</p></div>
      </div>

      {dls.length > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-xl overflow-hidden mb-6" data-testid="erp-dead-letters">
          <div className="px-4 py-3 border-b border-red-200 font-semibold text-red-800">Dead-Letter-Queue ({dls.length})</div>
          <Table><TableHeader><TableRow><TableHead>Beleg</TableHead><TableHead>Typ</TableHead><TableHead>Fehler</TableHead><TableHead></TableHead></TableRow></TableHeader>
            <TableBody>{dls.map((d) => (
              <TableRow key={d.id} data-testid={`dl-row-${d.doc_number}`}><TableCell className="font-mono">{d.doc_number}</TableCell><TableCell>{d.doc_type}</TableCell>
                <TableCell className="text-sm text-red-700">{d.error}</TableCell>
                <TableCell><Button size="sm" variant="outline" data-testid={`dl-retry-${d.doc_number}`} disabled={busy} onClick={() => retry(d)}><RefreshCw className="h-4 w-4 mr-1" /> Wiederholen</Button></TableCell></TableRow>
            ))}</TableBody></Table>
        </div>
      )}

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100 font-semibold text-[#1B2A4A]">Nachrichtenprotokoll</div>
        <Table><TableHeader><TableRow><TableHead>Beleg</TableHead><TableHead>Typ</TableHead><TableHead>Richtung</TableHead><TableHead>Status</TableHead><TableHead>Zeit</TableHead></TableRow></TableHeader>
          <TableBody>
            {msgs.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-gray-400 py-8">Keine Nachrichten</TableCell></TableRow>}
            {msgs.map((m) => { const [c, l] = STATUS[m.status] || ["bg-gray-100", m.status]; return (
              <TableRow key={m.id} data-testid={`erp-msg-${m.doc_number}`}><TableCell className="font-mono">{m.doc_number}</TableCell><TableCell>{m.doc_type}</TableCell>
                <TableCell>{m.direction}</TableCell><TableCell><Badge className={c}>{l}</Badge></TableCell><TableCell className="text-sm text-gray-500">{fmtDate(m.created_at)}</TableCell></TableRow>
            ); })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
